import { AlmanacContent } from "../../components/config";

export default function Almanac() {
  return (
    <>
      <AlmanacContent />
    </>
  );
}
